import {ErrorHandler, Injectable} from "@angular/core";

import {RequestWrapper, EmptyResponse, LoggingRequest} from "@vhv/tarifrechner-common";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class PostErrorHandler extends ErrorHandler {

    private path:string = '/logging';

    constructor( protected readonly http: HttpClient) {
        super();
    }

    handleError(error: Error) {

        //try-catch um Endlosschleife zu vermeiden
        try {
            const logRequest = new LoggingRequest();
            logRequest.name = error.name;
            logRequest.message = error.message;
            logRequest.stack = error.stack;

            const wrapper = new RequestWrapper(logRequest);

            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type':  'application/json'
                })
            };

            this.http.post(this.path, JSON.stringify(wrapper), httpOptions).toPromise().then(value => {
                console.debug('Logging-Request erfolgreich verschickt.');
            }).catch(error => console.debug(error));

        } catch (e) {
            console.log("Error on sending error trace.", e);
        }
        super.handleError(error);
    }

}
